import { IPhaseSkillTarget } from "./trainingPhaseCreateMutation";
import { EntityTypes } from "../../EntityTypes";
import { ITrainingActionResource } from "../../training-actions";
import { createApiMutationHook, IApiMutationFunction } from "../../utils/api";
import { mapRelationalValue, mapRelationalValueAsIRI, RelationalValue } from "../../utils/filters";
import { ITrainingPhaseResource } from "../types";

export interface ITrainingPhaseUpdateMutationParameters {
    trainingPhase: RelationalValue<ITrainingPhaseResource>;
    trainingAction?: RelationalValue<ITrainingActionResource>;
    name?: string;
    modules?: string;
    duration?: number;
    rank?: number;
    skillTargets?: IPhaseSkillTarget[];
}

export type ITrainingPhaseUpdateMutationResult = ITrainingPhaseResource;

export const trainingPhaseUpdateMutation: IApiMutationFunction<ITrainingPhaseUpdateMutationParameters> = ({
    trainingPhase,
    trainingAction,
    name,
    modules,
    duration,
    rank,
    skillTargets,
}) => {
    const data: Record<string, unknown> = {};

    if (trainingAction !== undefined) {
        data.trainingAction = mapRelationalValueAsIRI(EntityTypes.TRAINING_ACTION, trainingAction);
    }
    if (name !== undefined) {
        data.name = name;
    }
    if (modules !== undefined) {
        data.modules = modules;
    }
    if (duration !== undefined) {
        data.duration = duration;
    }
    if (rank !== undefined) {
        data.rank = rank;
    }
    if (skillTargets !== undefined) {
        data.skillTargets = skillTargets;
    }

    return {
        method: "PATCH",
        url: `/training_phases/${mapRelationalValue(trainingPhase)}`,
        headers: {
            "Content-Type": "application/merge-patch+json",
        },
        data,
    };
};

export const useTrainingPhaseUpdateMutation = createApiMutationHook<
    ITrainingPhaseUpdateMutationParameters,
    ITrainingPhaseUpdateMutationResult
>(trainingPhaseUpdateMutation);
